var _ellipse, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathEscalator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3259,
    cy: 7.59795,
    rx: 1.67486,
    ry: 1.67486,
    fill: "#282D4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2798 12.5108V12.3433C16.2798 11.2642 15.405 10.3893 14.3258 10.3893C13.2467 10.3893 12.3718 11.2642 12.3718 12.3433V17.6471L16.2798 12.5108Z",
    fill: "#282D4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0927 12.3434C12.0927 11.11 13.0925 10.1102 14.3258 10.1102C15.5591 10.1102 16.5589 11.11 16.5589 12.3434V12.605L12.0927 18.475V12.3434ZM14.3258 10.6685C13.4008 10.6685 12.6509 11.4184 12.6509 12.3434V16.8192L16.0007 12.4167V12.3434C16.0007 11.4184 15.2508 10.6685 14.3258 10.6685Z",
    fill: "#282D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7707 8.15622H19.0713L10.1387 19.8802H6.23071V24.3465H12.9301L21.8627 12.6225H25.7707V8.15622Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7707 9.83105H19.0713L10.1387 21.5551H6.23071V26.0213H12.9301L21.8627 14.2973H25.7707V9.83105Z",
    fill: "#282D4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathEscalator);
export default __webpack_public_path__ + "static/media/path_escalator.ab9debf4d8ae491fe66ae673516dc2c1.svg";
export { ForwardRef as ReactComponent };